import { render, staticRenderFns } from "./GreyHeadBox.vue?vue&type=template&id=26ebf2e3&scoped=true"
import script from "./GreyHeadBox.vue?vue&type=script&lang=js"
export * from "./GreyHeadBox.vue?vue&type=script&lang=js"
import style0 from "./GreyHeadBox.vue?vue&type=style&index=0&id=26ebf2e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ebf2e3",
  null
  
)

export default component.exports